module.exports = __webpack_public_path__ + "static/media/mike.aab414f7.jpg";